import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GET_CASH_REWARDS_SSO, GET_WALLET_TRANSACTIONS, SSO_CASH_REWARDS, UrlBuilder } from '@app/core/core-api-variables';
import { HttpService } from '@app/core/shared';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable()

export class CashrewardsService {

  constructor(public http: HttpService, public httpClient: HttpClient) {

  }

  getCashRewardsSsoDetails():Observable<any>{
    return this.http.get(GET_CASH_REWARDS_SSO);
  }
  //ssoCashRewards(data):Observable<any>{
  //  return this.httpClient.post(`${environment.cashBaseUrl}${SSO_CASH_REWARDS}`, data);
  //}
  sso(data):Observable<any>{
    return this.httpClient.post(`http://localhost:4000/api/sso`, data);
  }

  getWalletTransactions(query: { page: number; perPage: number }): Observable<any> {
    const url = UrlBuilder(GET_WALLET_TRANSACTIONS, query);
    console.log('Wallet Transactions URL:', url);
    return this.http.get(url);
  }
  
}
